import { Link, Meta } from '../Pagination';

export interface CreateOfferRequest {
  currency?: Currency;
  name: string;
  price: number;
  sales_page: string;
  sku: string;
  payment_type: string;
  recurring_interval: string;
  trial_enabled?: boolean;
  trial_mode?: string | null;
  trial_price?: number | null;
  trial_interval?: string | null;
  is_affiliate_enabled: boolean;
  affiliate_commission_cycles?: number | null;
  payment_methods: string[];
  thank_you_page_bank_slip?: null | string;
  thank_you_page_card?: null | string;
  thank_you_page_pix?: null | string;
  is_active?: boolean;
  [property: string]: any;
}

export interface OfferData extends CreateOfferRequest {
  price_formatted: string;
  display_name?: string | null;
  paymentMethods: {
    name: string;
    type: string;
    countries?: string[];
  }[];
}

export interface OffersResponse {
  data: OfferData[];
  meta: Meta;
  links: Link;
}

export enum Currency {
  Brl = 'BRL',
  Dol = 'DOL',
  Eur = 'EUR',
}
